import React, { useCallback, useContext, useState } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useModal } from '@jutro/components';
import { GatewayRenewalService as LoadSaveService } from 'twia-capability-gateway-policyrenewal';
import { TWIAAccountHolderEdit } from 'twia-capability-renewal-ho-react'
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss'
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil.js';
import metadata from './PolicyDetailsPage.metadata.json5';
import messages from './PolicyDetails.messages.js';


function PolicyDetailsPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext)
    const { wizardData: submissionVM, updateWizardData, id } = props;
    const { authHeader } = useAuthentication();
    const { onValidate, isComponentValid, initialValidation } = useValidation(id);
    const [showErrors, setShowErrors] = useState(false);
    const [editPrimaryName, setEditPrimaryName] = useState(false);
    const { showAlert } = useModal();
    const { refreshData } = useDataRefresh();

    const onNext = useCallback(async () => {
        if (editPrimaryName) {
            return showAlert({
                title: messages.saveModalTitle,
                message: messages.saveModalText,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.close,
            }).then(() => false)
        }

        if (!isComponentValid) {
            setShowErrors(true)

            return false
        }

        try {
            _.unset(submissionVM.value, 'bindData');
            
            const newSubmissionVM = viewModelService.clone(submissionVM);

            submissionVM.value = await LoadSaveService.saveRenewal(
                [newSubmissionVM.value],
                authHeader
            )

            return submissionVM
        } catch (error) {
            const selectedUWCompany = _.get(submissionVM, 'baseData.associationName_TWIA.value.code');
            const isTWIA = selectedUWCompany === 'twia';

            ErrorPopupUtil.showSaveErrorPopup(showAlert, isTWIA);
            
            return false;
        }
    }, [editPrimaryName, isComponentValid, showAlert, submissionVM, viewModelService, authHeader]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            updateWizardData(submissionVM);
            refreshData();
        },
        [refreshData, submissionVM, updateWizardData]
    );

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true
        },
        effectiveDate:{
            readOnly: true
        },
        accountHolderEdit: {
            fieldLabel:  messages.fieldLabel, // DE17087
            submissionVM,
            updateWizardData,
            editPrimaryName,
            setEditPrimaryName
        },
        spaceAccountHolder: {
            visible: submissionVM.value.baseData.productName === "Commercial"
        },
        description: {
            visible: submissionVM.value.baseData.productName === "Commercial"
        },
        spaceDescription: {
            visible: submissionVM.value.baseData.productName === "Commercial"
        },
        companyName: {
            visible: submissionVM.value.baseData.productName === "Commercial"
        }
    };

    const resolvers = {
        resolveComponentMap: {
            TWIAAccountHolderEdit
        },
        resolveClassNameMap: wizardStyles
    }

    // DE17587
    const skip = useCallback(async () => {
        const ppStatus = _.get(submissionVM.value, 'baseData.periodStatus') 
        || _.get(submissionVM.value, 'status');
        // DE18778
        
        return (await initialValidation()) && (ppStatus === 'Quoted'|| ppStatus === 'Renewing');
    }, [initialValidation, submissionVM]);

    return (

        <WizardPage
            id={id}
            showPrevious={false}
            onNext={onNext}
            skipWhen={skip}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                showErrors={showErrors}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={writeValue}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

PolicyDetailsPage.propTypes = wizardProps;
export default PolicyDetailsPage;
